<template>
  <vue-drawer-layout
      ref="drawer"
      :drawer-width="300"
      :enable="false"
      @mask-click="closeDrawer">

    <div slot="drawer">
      <NavigationDrawer :close="closeDrawer" class="navigation-drawer"/>
    </div>

    <div slot="content" class="root-pane">
      <div><InternetOnOff/></div>
      <Update
          title="Update Coming Up"
          message="Please watch Tutorial to get familiar with the interface."
          refresh-button-text="Watch Tutorial"
          later-button-text="Not Now"
          :show-later="true"
          @dismissed="showAlert"
      />
      <NavigationBar :toggle="openDrawer" class="nav"/>
      <div class="navigation-route-view">
          <router-view/>
      </div>
    </div>
  </vue-drawer-layout>
</template>

<script>
import NavigationBar from "@/components/layout/navigation/NavigationBar";
import NavigationDrawer from "@/components/layout/navigation/NavigationDrawer";
import InternetOnOff from "@/components/layout/NetworkChecker";
import Update from "@/components/layout/Update.vue";

export default {
  name: "Layout",
  computed: {
    getSaleUnits() {
      return this.$store.getters.getSaleUnits
    },
  },
  components: {NavigationDrawer, NavigationBar, InternetOnOff,Update},
  data(){
    return {
      showAlert: true,
    }
  },
  methods: {
    openDrawer() {
      if (!this.getSaleUnits) {
        this.$refs.drawer.toggle();
      }
    },
    closeDrawer() {
      this.$refs.drawer.toggle(false);
    },
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  display: flex;
  justify-content: center; /* Center contents horizontally */
  margin-bottom: 10px; /* Adjust as needed */
}

.red-background-blink {
  background-color: #ffc400;
  animation: blink 1s infinite;
  padding: 10px 20px; /* Adjust height and width */
  //border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.root-pane {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.navigation-drawer {
  min-width: 285px;
  width: 100%;
  height: 100vh;
}

.navigation-route-view {
  transition: 0.5s ease;
  //padding-bottom: 40px !important;
}

.offline-banner {
  position: sticky;
  top: 0;
  left: 0;
  padding: 5px;
  display: block;
  text-align: center;
  width: 100%;
  background: rgb(220, 53, 69);
  color: white;
  right: 0;
}
</style>
